import React, { forwardRef, HTMLProps } from 'react';
import { useHighlightingContext } from './HighlightingContext';

// Part of HighlightingContext. Simple div that would highlight
// everything inside with the highlightColor

// backgroundColor would be changed via style prop to:
// 1. properly override css
// 2. its dynamic and, it's not correct to use styled-components for it

interface IProps extends HTMLProps<HTMLDivElement> {
  defaultHighlighted?: boolean;
}

const HighlightedEntity = forwardRef<HTMLDivElement, IProps>(
  ({ children, defaultHighlighted, ...props }, ref) => {
    const { highlighted, highlightColor } = useHighlightingContext();

    return (
      <div
        {...props}
        ref={ref}
        style={{
          backgroundColor: Boolean(highlighted || defaultHighlighted)
            ? highlightColor
            : '',
        }}
      >
        {children}
      </div>
    );
  },
);

export default HighlightedEntity;
